import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { faTimes, faVoteYea } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { Check2Square, ExclamationTriangle, List, QuestionDiamond, Tools } from "react-bootstrap-icons";
import { checkCardStatus, activeCard, getAllGuaranteeHolders } from "../store/api/GuaranteeApi";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import {  keyIsLetterOrNumber, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker2";
import QRCodeReader from "../../Components/Modals/QR_Reader";
import barCodeImg from "../../content/images/barcodeReader.png";
import { useHistory } from "react-router-dom";

const ModalActiveGuaranteeCard = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const checkStatusData = useRef({});
    const isMobile = useIsMobileApp();
    const [holderList, setHolderList] = useState(null);
    const [modalCustomer, setModalCustomer] = useState({ show: false });
    const [inquiryResult, setInquiryResult] = useState(null);
    const [activeData, setActiveData] = useState({});
    const [modalQrCode, setModalQrCode] = useState({ show: false });
    const [error, setError] = useState(null);
    const { show } = popData;
    function close() {
        setPopData({
            show: false
        })
        setInquiryResult(null);
        setActiveData({});
        checkStatusData.current = {};
    }
    function checkStatus(e) {
        if (e?.key && e.key !== "Enter") {
            return;
        }
        setError(null);
        setInquiryResult(null);
        const onGet = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                if ((res.GuarantyStartDate ?? "") !== "") {
                    setError("درصورت فعال سازی تاریخ آغاز گارانتی تغییر خواهد کرد");
                }
                setInquiryResult(res);
            }
        }
        if (!checkStatusData.current.HolderID) {
            setError("برند گارانتی کننده انتخاب نشده است.");
            return;
        }
        if ((checkStatusData.current.Serial ?? "") === "" && (checkStatusData.current.CardNo ?? "") === "") {
            setError("دست کم یکی از کادرهای شماره سریال یا شماره کارت باید پر شود");
            return;
        }
        checkCardStatus(checkStatusData.current.HolderID, checkStatusData.current.Serial, checkStatusData.current.CardNo, onGet);
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
        }
        const onSelect = (cust) => {
            if (cust?.ID) {
                setActiveData({ ...activeData, CustomerID: cust.ID, CustomerName: cust.Name });
            }
        }
        setModalCustomer({
            show: true,
            setCustomerData: onSelect
        })
    }
    function submitData() {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
                return;
            }
            setErrorDialog(dispatch, "success", "فعال سازی کارت گارانتی");
            close();
        }
        if ((activeData.ActiveDate ?? "") === "") {
            activeData.ActiveDate = new Date();
        }
        activeData.CardID = inquiryResult.ID;
        activeCard(activeData, onSuccess);
    }
    function onScanQrCode(type, value) {
        document.getElementById(type).value = value;
        checkStatusData.current[type] = value;
        checkStatus();
    }
    function showModalQrCode(type) {
        setModalQrCode({
            show: true,
            onScan: (value) => onScanQrCode(type, value)
        })
    }
    const openService = () => {
        close();
        const serviceInfo = { GuaranteeCardID: inquiryResult.ID };
        if (inquiryResult.RelatedProductID) {
            serviceInfo.ProductID = inquiryResult.RelatedProductID;
        }
        if (inquiryResult.RelatedProductModel) {
            serviceInfo.ProductModel = inquiryResult.RelatedProductModel;
        }
        if (inquiryResult.RelatedProductName) {
            serviceInfo.ProductName = inquiryResult.RelatedProductName;
        }
        inquiryResult.SupportID = 1;
        if (inquiryResult.GuarantyEndDateTime) {
            serviceInfo.GuaranteeEndDate = inquiryResult.GuarantyEndDateTime;
        }
        if (inquiryResult.GuarantyStartDateTime) {
            serviceInfo.GuaranteeStartDate = inquiryResult.GuarantyStartDateTime;
        }
        if (inquiryResult.GuarantyCode) {
            serviceInfo.GuaranteeCardNo = inquiryResult.GuarantyCode;
        }
        if ((serviceInfo.GuaranteeStartDate ?? "") !== '' && (serviceInfo.GuaranteeEndDate ?? "") !== '') {


            const endDate = new Date(serviceInfo.GuaranteeEndDate);
            const startDate = new Date(serviceInfo.GuaranteeStartDate);

            let months = endDate.getMonth() - startDate.getMonth()
                + (12 * (endDate.getFullYear() - startDate.getFullYear()));

            if (endDate.getDate() < startDate.getDate()) {
                months--;
            }
            serviceInfo.GuaranteeTimeInMonth = months;
        }
        history.push(`/Services/Service/0/0`, serviceInfo);
    }
    useEffect(() => {
        if (show) {
            getAllGuaranteeHolders(null, setHolderList);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <ModalSelectCustomer setCustomerPopup={setModalCustomer} popData={modalCustomer} />
            <QRCodeReader popData={modalQrCode} setPopData={setModalQrCode} />
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon size="lg" icon={faVoteYea} />
                    &nbsp; فعال سازی کارت گارانتی
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "3px" }}>
                {error &&
                    <Alert variant="danger">
                        <ExclamationTriangle size={18} />&nbsp;
                        {error}
                        <FontAwesomeIcon icon={faTimes} style={{ float: "left" }} size="lg" onClick={() => setError(null)} />
                    </Alert>}
                <Row style={{ margin: 0 }}>
                    <FormGroup className="col-md-4" style={{ padding: "3px" }}>
                        {
                            Array.isArray(holderList ?? "") ?
                                <select className="form-control" onChange={e => checkStatusData.current.HolderID = e.target.value}>
                                    <option value="">برند را انتخاب کنید</option>
                                    {holderList.map((item, i) =>
                                        <option key={i} value={item.ID}>{item.HolderName}</option>)
                                    }
                                </select> :
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                        }
                    </FormGroup>
                    <Col md={4} className="form-group" style={{ padding: "3px" }}>
                        <Form.Control placeholder="شماره کارت گارانتی" id="CardNo" onChange={e => checkStatusData.current.CardNo = e.target.value} onKeyDown={checkStatus} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                        {isMobile &&
                            <Button variant='outline-danger' className="btn-input-tiny" onClick={() => showModalQrCode("CardNo")} style={{ top: 9, left: 4 }}>
                                <img src={barCodeImg} alt="" style={{ height: "26.5px" }} />
                            </Button>
                        }
                    </Col>
                    <Col md={4} className="form-group" style={{ padding: "3px" }}>
                        <Form.Control placeholder="شماره سریال" id="Serial" onChange={e => checkStatusData.current.Serial = e.target.value} onKeyDown={checkStatus} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                        {isMobile &&
                            <Button variant='outline-danger' className="btn-input-tiny" onClick={() => showModalQrCode("Serial")} style={{ top: 9, left: 4 }}>
                                <img src={barCodeImg} alt="" style={{ height: "26.5px" }} />
                            </Button>
                        }
                    </Col>
                    <Button className="group-Btn-large" style={{ margin: "auto", width: "98%" }} title="استعلام کارت" onClick={checkStatus}><QuestionDiamond size={18} />&nbsp; استعلام کارت</Button>

                    {
                        inquiryResult === "PENDING" &&
                        <div style={{ width: "100%", textAlign: "center", marginTop: "5px" }}>
                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                        </div>
                    }
                    {inquiryResult && inquiryResult !== "PENDING" && !(Number(inquiryResult.ID) > 0) &&
                        <Alert variant="warning mt-2">
                            <ExclamationTriangle color="orange" size={18} />&nbsp;
                            کارتی با این مشخصات در سیستم وجود ندارد.
                        </Alert>
                    }
                    {Number(inquiryResult?.ID) > 0 &&
                        <Fragment>
                            <table className="mt-2" style={{ margin: "auto", border: "1px solid black", padding: "3px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px", paddingTop: "5px" }}>وضعیت کارت: </td>
                                        <td style={{ paddingLeft: "5px", paddingTop: "5px", color: inquiryResult.GuarantyStatus !== "گارانتی دارد." ? "red" : "blue" }}>{inquiryResult.GuarantyStatus}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>وضعیت استفاده: </td>
                                        <td style={{ paddingLeft: "5px", color: inquiryResult.IsUsedInServices ? "red" : "blue" }}>{inquiryResult.IsUsedInServices ? ("استفاده شده") : ("استفاده نشده")}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>شماره کارت: </td>
                                        <td style={{ paddingLeft: "5px" }}>{inquiryResult.GuarantyCode}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>شماره سریال: </td>
                                        <td style={{ paddingLeft: "5px" }}>{inquiryResult.SerialNumber}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>برند گارانتی کننده: </td>
                                        <td style={{ paddingLeft: "5px" }}>{inquiryResult.HolderName}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>نام محصول: </td>
                                        <td style={{ paddingLeft: "5px" }}>{inquiryResult.RelatedProductName}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>مدل محصول: </td>
                                        <td style={{ paddingLeft: "5px" }}>{inquiryResult.RelatedProductModel}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px" }}>تاریخ آغاز گارانتی: </td>
                                        <td style={{ paddingLeft: "5px" }}>{inquiryResult.GuarantyStartDate}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px", paddingBottom: "5px" }}>تاریخ پایان گارانتی: </td>
                                        <td style={{ paddingLeft: "5px", paddingBottom: "5px" }}>{inquiryResult.GuarantyEndDate}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: "bold", paddingRight: "5px", paddingBottom: "5px" }}>مدت گارانتی: </td>
                                        <td style={{ paddingLeft: "5px", paddingBottom: "5px" }}>{`${inquiryResult.GaranteeTimeInMonth} ماه`}</td>
                                    </tr>                                    
                                </tbody>
                            </table>
                            <Row className="rowBorder mt-2">
                                <Col md={6} className="form-group" style={{ padding: 3 }}>
                                    <label>تاریخ فروش: </label>
                                    <DatePicker className="form-control" isGregorian={false} timePicker={false} value={momentJalaali()}
                                        onChange={val => activeData.ActiveDate = val.local("en").format("YYYY-MM-DD")} />
                                </Col>
                                <Col md={6} className="form-group" style={{ padding: 3 }}>
                                    <label>نام فروشگاه: </label>
                                    <Form.Control onChange={e => activeData.ShopName = e.target.value} />
                                </Col>
                                <Col md={8} className="form-group mt-1" style={{ padding: 3 }}>
                                    <label>مشخصات مشتری: </label>
                                    <Form.Control readOnly value={activeData?.CustomerName ?? ""} onKeyDown={showModalCustomer} />
                                    <Button className="btn-input-tiny" onClick={showModalCustomer} style={{ top: 30, left: 5 }}><List size={22} /></Button>
                                </Col>
                                <div style={{ padding: 0 }}>
                                    <Button variant="info" className="group-Btn mt-1" style={{ marginRight: "3px" }} onClick={submitData}
                                        disabled={(inquiryResult.IsUsedInServices ?? false) || (inquiryResult.GuarantyStatus !== "گارانتی دارد.")}>
                                        <Check2Square size={18} />&nbsp;فعال سازی گارانتی
                                    </Button>
                                    <Button className="group-Btn mt-1" onClick={openService} >
                                        <Tools size={18} />&nbsp; ثبت پذیرش
                                    </Button>
                                </div>

                            </Row>
                        </Fragment>}
                </Row>
            </Modal.Body>
        </Modal >
    )
}
export default ModalActiveGuaranteeCard;